export const dummyDashboard = {
  result: {
    schools: [
      {
        id: "1",
        name: "Green Valley School",
        address: "Sector 45, Gurgaon",
        pincode: "122003",
        landmark: "Near Huda City Centre",
        phone: "9876543210",
        email: "school1@gmail.com",
        createdOn: "2026-03-01",
      },
    ],

    cameras: [
      {
        id: "1",
        number: "CAM-001",
        key: "KEY-123456",
        sim: "9876543210",
        driver: "Ravi Kumar",
        status: true,
      },
    ],

    parents: [
      {
        id: "1",
        name: "Karan Lamba",
        email: "karan@test.com",
        phone: "9999999999",
        childCount: 2,
      },
    ],

    captains: [
      {
        id: "1",
        name: "Ravi Kumar",
        phone: "9876543210",
        createdAt: "2026-03-20",
      },
    ],

    bookings: [
      {
        id: "1",
        parent: "Karan Lamba",
        phone: "9999999999",
        child: "Aarav",
        grade: "5",
        emergencyName: "Mother",
        emergencyPhone: "8888888888",
      },
    ],
  },
};